import { useGetKycUserInfo as useGetKycUserInfoQuery } from '@xhype/card-app-sdk';

/* Types */
type TUseGetUserKycInfoProps = {
  id: number | undefined;
};

/* Hook */
export const useGetUserKycInfo = ({ id }: TUseGetUserKycInfoProps) => {
  const {
    data: kycUserInfo,
    isLoading,
    isError,
    error,
    refetch,
  } = useGetKycUserInfoQuery({
    enabled: !!id,
    userId: id ?? 0,
  });

  /* Return */
  return {
    isLoading,
    kycUserInfo,
    isError,
    error,
    refetch,
  };
};
